export default {
  birthdayConstraints (state, getters) {
    if (!state.order.insuredRelation) return
    const insuredRelation = state.order.insuredRelation
    let age = null
    for (let i = 0, l = state.config.form.insuredRelations.list.length; i < l; i++) {
      if (state.config.form.insuredRelations.list[i].value === insuredRelation) {
        age = state.config.form.insuredRelations.list[i].age
        break
      }
    }

    let d = {
      startDate: '',
      endDate: '',
      placeholder: '请选择被保人年龄'
    }
    const now = new Date()
    const nowYear = now.getFullYear()
    const nowMonth = now.getMonth()
    const nowDate = now.getDate()

    let endDate = null
    if (age.beginAge.unit === 'y') {
      endDate = new Date(nowYear - age.beginAge.value, nowMonth, nowDate)
      d.placeholder += '(' + age.beginAge.value + '周岁'
    } else if (age.beginAge.unit === 'd') {
      if (age.beginAge.include) {
        endDate = new Date(nowYear, nowMonth, nowDate - age.beginAge.value + 1)
      } else {
        endDate = new Date(nowYear, nowMonth, nowDate - age.beginAge.value)
      }
      d.placeholder += '(' + age.beginAge.value + '天'
    }

    let startDate = null
    if (age.endAge.unit === 'y') {
      startDate = new Date(nowYear - age.endAge.value - 1, nowMonth, nowDate + 1)
      d.placeholder += '-' + age.endAge.value + '周岁)'
    } else if (age.beginAge.unit === 'd') {
      startDate = new Date(nowYear, nowMonth, nowDate - age.endAge.value)
      d.placeholder += '-' + age.endAge.value + '天)'
    }

    d.startDate = startDate.getFullYear() + '-' + ((startDate.getMonth() + 1) < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
    d.endDate = endDate.getFullYear() + '-' + ((endDate.getMonth() + 1) < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) + '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())

    return d
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js